/**
 * Animated decorative background for the Initialization Loading screen.
 */

import React from "react";

import { Box, useTheme } from "@mui/material";

export const LoadingBackground: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage:
          "radial-gradient(circle at 20% 50%, " +
          theme.palette.primary.main +
          " 0%, transparent 50%), radial-gradient(circle at 80% 80%, " +
          theme.palette.secondary.main +
          " 0%, transparent 50%)",
        pointerEvents: "none",
      }}
    />
  );
};

export default LoadingBackground;
